import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Loader from 'components/common-components/Loader';
import ProfileDetails from './ProfileDetails';
import ProfileNotifications from './ProfileNotifications';
import TabHeader from 'components/tab-components/TabHeader';
import TabLayout from 'components/tab-components/TabLayout';
import { ProfileTabsList } from './utils';
import { CallAPI } from 'actions/General';

function Profile() {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(ProfileTabsList[0]);
  const [profileDetails, setProfileDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  const getUserProfileDetails = async () => {
    const response = await CallAPI('GET_USER_PROFILE_DETAILS', null, null, setLoading);
    if (response.status) {
      setProfileDetails(response.data);
    }
  };

  useEffect(() => {
    getUserProfileDetails();
  }, []);

  return (
    <div className='my-profile'>
      <span className='profile-heading px-4'>{t('tabs_my_profile')}</span>
      <span className='profile-desc px-4'>{t('text_manage_all_user_profile_settings')}</span>
      <TabLayout>
        <TabHeader
          tabList={ProfileTabsList}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          variant='iconTab'
        />
        <div className='p-4'>
          {loading && <Loader color='green-1' type='modal-spinner' />}
          {profileDetails && (
            <Fragment>
              {selectedTab.value === 'details' ? (
                <ProfileDetails
                  userProfileDetails={profileDetails}
                  getUserProfileDetails={getUserProfileDetails}
                />
              ) : (
                <ProfileNotifications />
              )}
            </Fragment>
          )}
        </div>
      </TabLayout>
    </div>
  );
}
export default Profile;
